export default "__VITE_ASSET__DLsPSm_g__"